var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.324 9.58068H1.676C1.30251 9.58068 1 9.88319 1 10.2567C1 10.3986 1.04394 10.5305 1.1183 10.6386C1.15041 10.7147 1.19942 10.7857 1.26026 10.8482L4.23974 13.826C4.37156 13.9578 4.54394 14.0237 4.71801 14.0237C4.89208 14.0237 5.06446 13.9578 5.19628 13.826C5.45992 13.5623 5.45992 13.1348 5.19628 12.8694L3.25616 10.9327H14.3223C14.6958 10.9327 14.9983 10.6302 14.9983 10.2567C14.9983 9.88319 14.6975 9.58068 14.324 9.58068ZM1.676 6.44403H14.324C14.6975 6.44403 15 6.14152 15 5.76803C15 5.62607 14.9561 5.49425 14.8817 5.38609C14.858 5.33032 14.8242 5.27624 14.7837 5.22554L12.3467 2.24775C12.1101 1.95876 11.6842 1.91651 11.3952 2.15311C11.1062 2.38971 11.064 2.81559 11.3006 3.10458L12.9281 5.09203H1.676C1.30251 5.09203 1 5.39454 1 5.76803C1 6.14152 1.30251 6.44403 1.676 6.44403Z",
    fill: "#2469EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.7edfcbcbbcca0148fc0affdc7ea00601.svg";
export { ForwardRef as ReactComponent };